<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2024-06-06 14:26:42
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-06-06 14:30:48
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/orderDetails/list/components/zsPartnerSelect/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-select
		v-bind="$attrs"
		v-model="userId"
		clearable
		filterable
		:placeholder="placeholder"
		:multiple="multiple"
		:collapse-tags="collapseTags"
		@change="change"
	>
		<el-option v-for="item in optionList" :key="item.userId" :value="item.userId" :label="item.name">
			<div class="flex flex-align-center">
				<span class="mr-8">{{ item.name }}</span>
				<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
				<el-tag v-else-if="item.use_status == 2" type="danger" size="mini">账号已停用</el-tag>
			</div>
		</el-option>
	</el-select>
</template>
<script>
import { getZsSelectList } from '@/api/teamManage';
export default {
	name: 'DrPartnerSelect',
	props: {
		value: [String, Number, Array],
		placeholder: {
			type: String,
			default: `请选择招商运营`,
		},
		customData: {
			type: Array,
			default: _ => [],
		},
		collapseTags: {
			type: Boolean,
			default: false,
		}, // 是否开启 多选时是否将选中值按文字的形式展示
		multiple: {
			type: Boolean,
			default: false,
		}, // 是否多选
	},
	data() {
		return {
			userId: this.value,
			optionList: [],
		};
	},
	watch: {
		value(val) {
			this.userId = val;
		},
	},
	mounted() {
		this.getCommonList();
	},
	methods: {
		change(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		async getCommonList() {
			const { code, data } = await getZsSelectList();
			if (code !== 0) return;
			// 将数组分成三个部分
			const notUseStatus2AndNotDeleted = data.filter(item => item.use_status != 2 && !item.deleted);
			const useStatus2 = data.filter(item => item.use_status == 2);
			const deleted = data.filter(item => item.deleted);
			// 合并三个部分
			this.optionList = [...this.customData, ...notUseStatus2AndNotDeleted, ...useStatus2, ...deleted];
		},
	},
};
</script>
<style lang="less" scoped>
.footer-option {
	padding: 8px 0px;
	height: auto !important;
	line-height: initial;
}
.footer-img {
	img {
		width: 36px;
		height: 36px;
		border-radius: 50%;
	}
}
.all {
	height: 43px;
	padding-left: 46px;
	line-height: 43px;
}
</style>
